import React from 'react';
import s from './Checkbox.module.scss';

interface CheckboxProps {
  label: string;
  value: string | boolean | object;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  id: string | number;
  className?: string;
  checkboxLabelClass?: string;
  isLabelClickable?: boolean;
  testId?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  value,
  onChange,
  id,
  testId,
  className = '',
  checkboxLabelClass = '',
  isLabelClickable = false,
}) => {
  return (
    <div className={`${s.checkboxWrapper} ${className}`}>
      <input
        type="checkbox"
        data-testid={testId}
        checked={!!value}
        onChange={onChange}
        id={id.toString()}
        className="flex-none"
      />
      <label
        className={`${s.checkboxLabel} ${checkboxLabelClass} ${isLabelClickable ? 'cursor-pointer' : 'pointer-events-none'}`}
        htmlFor={id.toString()}
      >
        {label}
      </label>
    </div>
  );
};

export default React.memo(Checkbox);
